module.exports = __webpack_public_path__ + "static/media/midwestern_hero.d9a06031.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/midwestern_hero.webp
// module id = 231
// module chunks = 0